import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
import FirstUpper from '../FirstUpper';

interface Props {
	onClick: () => void;
	text: string;
	firstUpper?: boolean;
	className?: string;
}

const Button: React.FC<Props> = ({
																	 onClick,
																	 text,
																	 firstUpper = false,
																	 className,
																 }) => {
	const { t } = useTranslation();

	let title: any = t(text);

	if (firstUpper) {
		title = <FirstUpper>{title}</FirstUpper>;
	}

	return (
		<a className={['btn btn-submit', className].join(' ')} onClick={onClick}>
			{title}
		</a>
	);
};

export default Button;
